import React, { useState } from 'react'
import Modal from '../../../../components/Modal'
import AddressInputPanel from '../../../../components/AddressInputPanel'
import NFTButton from '../NFTButton'
import useENS from '../../../../hooks/useENS'
import { useSwapState, useSwapActionHandlers } from '../../../../state/swap/hooks'
import { useTransferNft } from '../../../../hooks/useNFTMarketPlace'
import { INFTTransferModalProps } from './models/INFTTransferModal'
import { NFTSellModalButtons, NFTSellModalMeta, NFTSellModalWrapper } from '../NFTSellModal/styles/styled'
import { ApprovalState } from '../../../../hooks/useApproveCallback'

export default function NFTTransferModal(props: INFTTransferModalProps) {
  const { NFTName, isOpen, onDismiss, tokenContractAddress, getSalesNFTItems, tokenId } = props
  const { recipient } = useSwapState()
  const { address: recipientAddress } = useENS(recipient)
  const { onChangeRecipient } = useSwapActionHandlers()
  const [transferNftCallBack] = useTransferNft(tokenId, tokenContractAddress, recipientAddress)
  const [approvePending, setApprovePending] = useState(ApprovalState.NOT_APPROVED)

  function transferNFT() {
    setApprovePending(ApprovalState.PENDING)
    transferNftCallBack()
      .then(() => {
        setApprovePending(ApprovalState.APPROVED)
        onDismiss()
        onChangeRecipient('')
        setTimeout(() => getSalesNFTItems(), 2000)
      })
      .catch(() => {
        setApprovePending(ApprovalState.NOT_APPROVED)
      })
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <NFTSellModalWrapper>
        <NFTSellModalMeta>Transfer: {NFTName}</NFTSellModalMeta>
        <AddressInputPanel id="NFTRecipient" value={recipient ? recipient : ''} onChange={onChangeRecipient} />
        <NFTSellModalButtons>
          <NFTButton
            className={approvePending === ApprovalState.PENDING ? 'pending' : ''}
            disable={approvePending === ApprovalState.PENDING}
            text={'Transfer'}
            onClick={transferNFT}
          />
          <NFTButton onClick={() => onDismiss()} text="Cancel" />
        </NFTSellModalButtons>
      </NFTSellModalWrapper>
    </Modal>
  )
}
